// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31wR7","title":"Info_title__3myIz","selects":"Info_selects__1xqda","requiredAsterisk":"Info_requiredAsterisk__3ECWr"};